// extracted by mini-css-extract-plugin
export var pillWrapper = "_n3-0";
export var showOverflow = "_n3-1";